<template>
    <div class="row">
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                First Name
                <small class="redText">required</small>
                <input type="text" name="firstName" class="form-control" placeholder="First Name" v-model="model.contactInfo.firstName">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Middle Initial
                <input type="text" name="middleInitial" class="form-control" maxlength="1" placeholder="Middle Initial" v-model="model.contactInfo.middleInitial">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Last Name
                <small class="redText">required</small>
                <input type="text" name="lastName" class="form-control" placeholder="Last Name" v-model="model.contactInfo.lastName">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%" v-if="relationships.length>0">
                Relationship
                <small class="redText">required</small>
                <select v-model="model.relationshipObject" type="text" class="form-control">
                    <option :disabled="relationship.disabled" v-for="relationship in relationships" :value="relationship">
                        {{ relationship.relationType }}
                    </option>
                </select>
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%" v-if="genders.length>0">
                Gender
                <small class="redText">required</small>
                <select v-model="model.contactInfo.genderCode" type="text" class="form-control">
                    <option v-for="gender in genders" :value="gender.genderCode">
                        {{ gender.genderName }}
                    </option>
                </select>
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label>
                DOB
                <small class="redText">required</small>
            </label><br/>
            <ac-date-picker v-model="model.birthDate"></ac-date-picker>
        </div>
        <div v-if="ssnRequired" class="col-lg-4 form-group">
            <label>
                Social Security Number
                <small class="redText">required</small>
            </label>
            <ac-social-security-number v-model="model.ssn"></ac-social-security-number>
        </div>
    </div>
</template>
<script>
    import {configTables} from "@/global/configTables.js";
    import {api} from "@/global/framework/api.js";

    export default {
        name: "AddDependentForm",
        props: {
            value: {type: Object, required: true},
            ssnRequired: {type: Boolean, default: false},
            companyId: {type: Number, default: 0},
        },
        data() {
            return {
                model: {
                    ...(this.clone(this.value)),
                    relationshipObject: {},
                    editMode: false,
                    isSpouse: false
                },
                genders: [],
                relationships: [],
            }
        },
        methods: {
            async getDependent() {
                this.model.relationshipToPrimary = this.model.relationshipObject.relationshipsEnum;
                if (this.model.relationshipToPrimary == 2) {
                    this.model.isSpouse = true;
                } else {
                    this.model.isSpouse = false;
                }
                if (this.companyId) {
                    this.model.company = { companyId: this.companyId };
                }
                let result = await api.post('ProviderSearch', 'ValidateDependent', this.model, true);
                if (result) {
                    return this.model;
                }
                return false;
            }
        },
        async mounted() {
            let [g, r] = await Promise.all([
                configTables.getGenders(),
                configTables.getRelationshipsToPrimary()
            ]);
            this.genders = g;
            this.relationships = r;

            if (!this.isSpouse && this.spouseDisabled) {
                this.relationships[0].disabled = true;
            }
        }
    }
</script>

<style scoped>

</style>